import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from 'react-router-dom';
import TableContainer from '../../../../Components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";
import roleSvg from '../../../../assets/images/svg/role.svg'
import { numberWithCommas } from "../../../../helpers/globalHelper"

import DeleteModal from '../../../../Components/Common/DeleteModal';

import { Col, Row, UncontrolledTooltip, Modal, ModalHeader, ModalBody, Form, Input, FormFeedback, Label, Card, CardBody, Button } from "reactstrap";

//flatpickr
import "flatpickr/dist/themes/material_green.css";
import Spinners from "Components/Common/Spinner";
import { useRoleCreateMutation, useRoleDeleteMutation, useRoleFindAllQuery, useRoleUpdateMutation } from '../../../../store';

const Detail = () => {
  const [customQuery, setCustomQuery] = useState<any>();
  const [isLoading, setLoading] = useState(true)

  const [modal, setModal] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [roleOne, setRoleOne] = useState<any>(null)
  const [roleList, setRoleList] = useState<any>();
  const [roleCount, setRoleCount] = useState<any>();

  const { data, error, isFetching } = useRoleFindAllQuery(customQuery);

  const [roleCreate, roleCreateResult] = useRoleCreateMutation();
  const [roleUpdate, roleUpdateResult] = useRoleUpdateMutation();
  const [roleDelete, roleDeleteResult] = useRoleDeleteMutation();

  // Datatable дээр pagination харуулахад хэрэгтэй
  const [customPagination, setCustomPagination] = useState<any>();
  const [customPageSize, setCustomPageSize] = useState<any>();
  const [customPageLength, setCustomPageLength] = useState<any>();

  useEffect(() => {
    setRoleList(data?.data)
    setLoading(false)
    setRoleCount(roleList?.length)

    setCustomPagination(data?.pagination)
    const tempQuery = `?page=${customPageLength !== undefined ? customPageLength : 1}&pageSize=${customPageSize !== undefined ? customPageSize : 25}`;
    setCustomQuery(tempQuery)
  }, [data, roleCount, customPageSize, customPageLength, customPagination])


  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setRoleOne(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleJobClick = useCallback((arg: any) => {
    const tempPosition = arg;
    setRoleOne({
      id: tempPosition.id,
      code: tempPosition.code,
      name: tempPosition.name,
      description: tempPosition.description,
      display: tempPosition.display
    });
    setIsEdit(true);
    toggle();
  }, []);

  //delete Job
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = (selectRowData) => {
    setRoleOne(selectRowData);
    setDeleteModal(true);
  };

  const handleDeletejob = () => {
    if (roleOne) {
      roleDelete(roleOne.id)
      setDeleteModal(false);
    }
  };
  const handleJobClicks = () => {
    setIsEdit(false);
    setRoleOne(null);
    toggle();
  };

  const columns = useMemo(
    () => [
      {
        header: '№',
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps: any) => {
          return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
        }
      },
      {
        header: "Код",
        accessorKey: "code",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Нэр",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Тайлбар',
        accessorKey: "description",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'display',
        accessorKey: "display",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Үйлдэл',
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps: any) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-info"
                  onClick={(event: any) => {
                    const positionData = cellProps.row.original;
                    event.preventDefault();
                    handleJobClick(positionData);
                  }}
                >
                  <i className="mdi mdi-pencil-outline" id="edittooltip" />
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Засах
                  </UncontrolledTooltip>
                </Link>
              </li>

              <li>
                <Link
                  to={`/system/settings/menu/role/${cellProps.row.original.id}`}
                  className="btn btn-sm btn-soft-success"
                >
                  <i className="mdi mdi-format-list-bulleted" id="menutip" />
                  <UncontrolledTooltip placement="top" target="menutip">
                    Меню харах
                  </UncontrolledTooltip>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-danger"
                  onClick={(event: any) => {
                    const selectRowData = cellProps.row.original;
                    event.preventDefault();
                    onClickDelete(selectRowData);
                  }}
                >
                  <i className="mdi mdi-delete-outline" id="deletetooltip" />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Soft delete
                  </UncontrolledTooltip>
                </Link>
              </li>
            </ul>

          );
        }
      },
    ],
    [handleJobClick]
  );


  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      id: roleOne?.id,
      code: roleOne?.code,
      name: roleOne?.name,
      description: roleOne?.description,
      display: roleOne?.display,
    },
    validationSchema: Yup.object({
      code: Yup.string().required("Утга оруулна уу !"),
      name: Yup.string().required("Утга оруулна уу !"),
      description: Yup.string().required("Утга оруулна уу !"),
      display: Yup.string().required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      if (isEdit) {
        const updateRoleList = {
          id: roleOne ? roleOne.id : 0,
          code: values.code,
          name: values.name,
          description: values.description,
          display: values.display,
        };
        roleUpdate(updateRoleList)
      } else {
        const newRoleList = {
          code: values["code"],
          name: values["name"],
          description: values["description"],
          display: values["display"],
        };
        roleCreate(newRoleList)
      }
      validation.resetForm();
      toggle();
    },
  });

  return (
    <React.Fragment>
      <DeleteModal
        deleteName={roleOne?.name}
        show={deleteModal}
        onDeleteClick={handleDeletejob}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Row>
        <Col lg={12}>
          <Card>
            <CardBody className="border-bottom">
              <div className="d-flex align-items-center">
                <img src={roleSvg} alt="" height="50" />
                <div className="flex-grow-1 ms-3">
                  <h5 className="fw-semibold">Мэдээлэл</h5>
                  <ul className="list-unstyled hstack gap-2 mb-0">
                    <li>
                      <i className="mdi mdi-table-row-height"></i> <span className="text-muted fw-semibold">Нийт: {numberWithCommas(roleCount)}</span>
                    </li>
                  </ul>
                </div>
                <button
                  type="button"
                  onClick={() => {
                    handleJobClicks();
                  }}
                  className="btn btn-success  btn-label"
                >
                  <i className="mdi mdi-file-plus-outline label-icon"></i> Шинээр нэмэх
                </button>
              </div>
            </CardBody>
            <CardBody>
              {
                isLoading ? <Spinners setLoading={setLoading} />
                  :
                  <TableContainer
                    columns={columns}
                    data={roleList || []}
                    isCustomPageSize={true}
                    isGlobalFilter={true}
                    isPagination={true}
                    colWidth={2}
                    SearchPlaceholder="Хэрэглэгч хайх . . ."
                    tableClass="align-middle dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                    pagination="pagination"
                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                  />
              }
            </CardBody>
          </Card>

        </Col>
      </Row>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle} tag="h4">
          {!!isEdit ? "Хандах эрх засах" : "Хандах эрх нэмэх"}
        </ModalHeader>
        <ModalBody>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <Row>
              <Col xs={12}>
                <div className="mb-3">
                  <Label> Хандах эрх </Label>
                  <Input
                    name="name"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name || ""}
                    invalid={
                      validation.touched.name && validation.errors.name ? true : false
                    }
                  />
                  {validation.touched.name && validation.errors.name ? (
                    <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label>Код</Label>
                  <Input
                    name="code"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.code || ""}
                    invalid={
                      validation.touched.code && validation.errors.code ? true : false
                    }
                  />
                  {validation.touched.code && validation.errors.code ? (
                    <FormFeedback type="invalid">{validation.errors.code}</FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Тайлбар</Label>
                  <Input
                    name="description"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.description || ""}
                    invalid={
                      validation.touched.description && validation.errors.description ? true : false
                    }
                  />
                  {validation.touched.description && validation.errors.description ? (
                    <FormFeedback type="invalid">{validation.errors.description}</FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label>Diplay</Label>
                  <Input
                    name="display"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.display || ""}
                    invalid={
                      validation.touched.display && validation.errors.display ? true : false
                    }
                  />
                  {validation.touched.display && validation.errors.display ? (
                    <FormFeedback type="invalid">{validation.errors.display}</FormFeedback>
                  ) : null}
                </div>


              </Col>
            </Row>
            <Row>
              <Col>
                <div className="text-end">
                  <Button type="submit" color="success" className="save-user" > Save</Button>
                </div>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
}


export default Detail;